import delay from "@/utils/delay";
import "./style.css";

export default class Accordion {
  static selector = ".accordion";

  constructor(block) {
    this.block = block;
    this.items = [];
    this.isAutoclose = true;
  }

  handleTitleClick = async (e) => {
    const activeItem = e.currentTarget.closest(".accordion__item");
    const activeItemContent = activeItem.querySelector(
      ".accordion__item-content"
    );

    if (activeItem.classList.contains("accordion__item--active")) {
      activeItemContent.style.height = null;
      activeItem.classList.remove("accordion__item--active");

      activeItem.dispatchEvent(new CustomEvent("accordion:item:close"));
    } else {
      activeItemContent.style.height = activeItemContent.scrollHeight + "px";

      await delay(20);

      activeItem.classList.add("accordion__item--active");
      activeItem.dispatchEvent(new CustomEvent("accordion:item:open"));

      if (this.isAutoclose) {
        // close all the other items
        this.items.forEach((item) => {
          if (item !== activeItem) {
            item.querySelector(".accordion__item-content").style.height = null;
            item.classList.remove("accordion__item--active");
            activeItem.dispatchEvent(new CustomEvent("accordion:item:close"));
          }
        });
      }
    }
  };

  onReady = () => {
    this.isAutoclose = this.block.classList.contains("accordion--autoclose");
    this.items = Array.from(this.block.querySelectorAll(".accordion__item"));

    Array.from(this.block.children).map((item, index) => {
      if (item.classList.contains("accordion__item--active")) {
        const itemContent = item.querySelector(".accordion__item-content");
        itemContent.style.height = itemContent.scrollHeight + "px";
      }

      item
        .querySelector(".accordion__item-handle")
        .addEventListener("click", this.handleTitleClick);
    });
  };
  onScroll = () => {};
  onDestroy = () => {};
}
